module.exports = __webpack_public_path__ + "img/juyoufuli_logo.20d1e78d.png";